import AP from "../legacy/global";
import { getApiUrl, getGatewayUrl } from "../utils/get-api-url";

const makeAttachmentAgentPortalCompatible = ({ attachment, quoteId }) => {
  if (attachment?.attachmentId) {
    return {
      ...attachment,
      href: `${getApiUrl("quotesapi")}/quotes/${quoteId}/attachments/${
        attachment.attachmentId
      }`
    };
  }

  return attachment;
};

/**
 * NOTE:
 * The GET fetch uses getApiUrl()
 * The POST and DELETE fetch use getGatewayUrl()
 * This is by design and NOT a mistake.
 *
 * TODO look into what authorization the referrals-api is looking for
 * and determine how to authenticate agents to correctly do the thing
 * as opposed to using a single user for it vie the gateway
 */

export const getReferrals = async ({ quoteId }) => {
  const apiUrl = getApiUrl("referrals");
  const fullUrl = `${apiUrl}/${quoteId}`;
  const response = await fetch(fullUrl, {
    credentials: "include"
  });

  if (!response.ok) throw new Error(response.statusText);
  const json = await response.json();

  const referrals = json.map(referral => ({
    ...referral,
    attachment: makeAttachmentAgentPortalCompatible({
      attachment: referral?.attachment,
      quoteId
    }),
    notes: referral?.notes?.map(note => ({
      ...note,
      attachments: note.attachments
        ? note.attachments.map(attachment =>
            makeAttachmentAgentPortalCompatible({
              attachment,
              quoteId
            })
          )
        : note.attachments
    }))
  }));

  return referrals;
};

export const withdrawReferral = async ({ quoteId, taskId }) => {
  const apiUrl = getGatewayUrl("referrals");
  const fullUrl = `${apiUrl}/${quoteId}?taskId=${taskId}`;

  const response = await fetch(fullUrl, {
    method: "DELETE",
    credentials: "include"
  });

  if (response.ok) {
    return response;
  }

  throw new Error("Failed to withdraw: Error code " + response.status);
};

export const submitReferral = async ({
  files = [],
  message,
  warnings = [],
  quoteId,
  taskId = "",
  disputedLossIndices = [],
  subtype = "QuotingEligibility"
}) => {
  const referrelJSON = JSON.stringify({
    createdBy: AP.u,
    content: message,
    referralType: "UnderwritingReferral",
    subtype: subtype,
    assignedTo: "Underwriting",
    blockingRulesetIds: warnings.map(
      warning => warning.rulesetId || warning.id
    ),
    disputedLossIndices,
    owningAgent: AP.u,
    ...(taskId && { taskId: taskId.toString() })
  });

  const formData = new FormData();
  formData.append("upload-type", "file");
  files.forEach(file => {
    formData.append("File", file);
  });
  formData.append("ReferralJson", referrelJSON);

  const apiUrl = getApiUrl("referrals");
  const fullUrl = `${apiUrl}/${quoteId}`;

  const response = await fetch(fullUrl, {
    method: "POST",
    credentials: "include",
    body: formData
  });

  if (response.ok) {
    return response;
  }

  throw new Error("Failed to submit referral: Error code " + response.status);
};
